import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue-toastification'
import '@a4pm/discador/dist/video-component.css'
import 'vue-toastification/dist/index.css'
import './assets/styles/toast-overrides.css'

Vue.config.productionTip = false

Vue.use(Toast, {
  shareAppContext: true
})

const isDevelopment = process.env.VUE_APP_ENVIRONMENT === 'development'

window.__DISCADOR_API_URL__ = isDevelopment
  ? ''
  : String(process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
